module.exports = __webpack_public_path__ + "img/dollar.8ecb475f.svg";